import PropTypes from "prop-types";
import React from "react";

import { inputPropTypes } from "@swa-ui/core";
import { TextFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import { CITY_MAX_LENGTH, CITY_SCHEMA_FIELD_NAME } from "./CityFormField.schema";

/**
 * CityFormField facilitates the input of a city.
 */

export const CityFormField = (props) => {
  const { componentProps, disabled, name = CITY_SCHEMA_FIELD_NAME } = props;

  return <TextFormField {...getTextFormFieldProps()} />;

  function getTextFormFieldProps() {
    return {
      componentProps: {
        "aria-label": i18n("CityFormField__ARIA"),
        maxLength: CITY_MAX_LENGTH,
        ...componentProps,
      },
      disabled,
      label: i18n("CityFormField__LABEL"),
      name,
    };
  }
};

export const cityFormFieldPropTypes = {
  /** Component props for input component. */
  componentProps: PropTypes.shape(inputPropTypes),

  /** Indicates whether the field is disabled. */
  disabled: PropTypes.bool,

  /** Form field name used in schema validation and service call payload. */
  name: PropTypes.string,
};

CityFormField.propTypes = cityFormFieldPropTypes;
